import { useEffect, useMemo, useState } from 'react';
import * as R from 'ramda';
import { CsvToHtmlTable } from 'react-csv-to-table';
import LoadingModal from '../dumb/LoadingModal';
import DownloadLink from "react-download-link";
import NotificationDisplay from '../dumb/NotificationDisplay';
import ExportLeadForm from "../../forms/ExportLeadForm";
import { getCourses, _exportLeads } from '../../util/api';
import { LeadStageOptions, LeadPipeline } from '../../constants/sales';

function ExportLeadComponent() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [notification, setNotification] = useState(undefined);
    const [courses, setCourses] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [selectedParams, setSelectedParams] = useState([]);
    const [selectedLeadStages, setSelectedLeadStages] = useState([]);
    const [selectedStartDate, setSelectedStartDate] = useState(undefined);
    const [selectedEndDate, setSelectedEndDate] = useState(undefined)
    const [batches, setBatches] = useState([]);
    const [exportedLeads, setExportedLeads] = useState(undefined);
    const [generatedReport, setGeneratedReport] = useState(undefined);
    const params = useMemo(
        () => {
            return [
                'leadId',
                'name',
                'email',
                'phoneNo',
                'dateAdded',

            ]   
        }
    , []);

    const leadStages = useMemo(
        () => {
            return LeadStageOptions
            .map(option => option.value)
        }
    ,[]);    

    const pipelineStages = useMemo(
        () => {
            return R.values(LeadPipeline);
        }
    ,[]); 

    useEffect(() => {
        setLoading(true);
        getCourses()
        .then(courses => {
            setCourses(courses);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        let batches = [];
        R.forEach(courseName => {
            let selectedCourse = R.find(course => course.courseName === courseName)(courses);
            batches.push(...selectedCourse.batches);
        })(selectedCourses);
        setBatches(batches);
    }, [courses, selectedCourses]);

    return (
        <>
            {
                loading && (
                    <LoadingModal />
                )
            }
            {
                !R.isNil(error) &&
                <div style={{ color: 'red' }}> { error } </div>
            }
            {
                !R.isNil(notification) &&
                (
                    <NotificationDisplay notificationText={notification} close={() => setNotification(undefined)} />
                )
            }
            <ExportLeadForm
                courses={courses}
                onSelectCourse={selectedCourses => setSelectedCourses(selectedCourses)}
                batches={batches}
                onSelectBatch={selectedBatches => setSelectedBatches(selectedBatches)}
                params={params}
                onSelectParam={selectedParams => setSelectedParams(selectedParams)}
                leadStages={leadStages}
                onSelectLeadStage={(leadStages) => setSelectedLeadStages(leadStages)}
                pipelineStages={pipelineStages}
                onSelectEndDate={endDate => setSelectedEndDate(endDate)}
                onSelectStartDate={startDate => setSelectedStartDate(startDate)}
                onClick={() => {
                    setLoading(true);
                    setExportedLeads(undefined);
                    let filterCondition = { };
                    if (selectedCourses.length > 0) {
                        filterCondition['targetCourse'] = selectedCourses;
                    }
                    if (selectedBatches.length > 0) {
                        filterCondition['targetBatch'] = selectedBatches;
                    }
                    if (selectedLeadStages.length > 0) {
                        filterCondition['leadStage']  = selectedLeadStages;
                    }
                    if (!R.isNil(selectedStartDate)) {
                        filterCondition['dateAddedStart'] = selectedStartDate;
                    }
                    if (!R.isNil(selectedEndDate)) {
                        filterCondition['dateAddedEnd'] = selectedEndDate;
                    }
                    _exportLeads(filterCondition, selectedParams)
                    .then(data => {
                        setNotification(`Export Complete. Total ${data.totalLeads} leads found!`);
                        setExportedLeads(data.csv);
                        setLoading(false);
                    })
                    .catch(error => {
                        setError(error);
                        setLoading(false);
                    })
                }}
            />
            {
                !R.isNil(exportedLeads) && (
                    <>
                        <DownloadLink
                            label="Download"
                            fileName="exported-leads.csv"
                            exportFile={() => exportedLeads}
                        />
                        <CsvToHtmlTable
                            data={exportedLeads}
                            delimiter=','
                            tableClassName="table table-striped table-hover"
                        />
                    </>
                )
            }
        </>
    );
}

export default ExportLeadComponent;